module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contribution-success"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.contribution.user) ? _c('div', [_c('h3', [_vm._v("Content visible only to contribution owners.")])]) : _c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('thank_you') + ', ' + _vm.contribution.user.full_name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.$t('contribution.success.content')))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('contribution.success.yourSupport') + ": " + (_vm.contribution.amount / 100) + ' ' + _vm.contribution.project.currency))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.contribution.project.title))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', {
    staticClass: "mb-50"
  }, [_vm._v("THX")]), _vm._v(" "), _c('router-link', {
    class: "btn btn-default btn-lg button-wide-" + _vm.crowd_or_rais,
    attrs: {
      "to": _vm.contribution.project.crowdfunding ? ("/crowdfunding/" + (_vm.contribution.project.id) + "/" + (_vm.contribution.project.title)) : ("/fundraising/" + (_vm.contribution.project.id) + "/" + (_vm.contribution.project.title))
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('contribution.success.back')))])], 1)]), _vm._v(" "), _c('crowd-or-rais')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23a1076a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ContributionSuccess.vue
// module id = 785
// module chunks = 1